import { useEffect, useState } from "react";
import Error404 from "../../../../../../Error404";
import { lineupViewDataAPI } from "../../../../../../../services/api/projectCurrent";
import { useParams } from "react-router-dom";



export default function LineupInfo(staff, others) {
    const [musicians, setMusicians] = useState({})
    const params = useParams()

    useEffect(() => {
        const get_DataAPI = async () => {
            const response = await lineupViewDataAPI(params.id)
            if (response.status === 200) {
                setMusicians(response.data)

            } else return <Error404/>
        }
        get_DataAPI()

    }, [params.id])

    return (<>
        <div>{JSON.stringify(musicians, null, 2)}</div>
    </>)
}

